module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dvktr"))).then(() => parcelRequire('3a9aZ'));